var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3C9.77614 3 10 3.22386 10 3.5C10 3.74177 9.82864 3.94378 9.60059 3.99023L9.39941 4.00977C9.17153 4.05636 9 4.25835 9 4.5V5.58008C9 5.855 9.07166 6.12554 9.20801 6.36426L12.1455 11.5039C12.5262 12.1704 12.0449 12.9998 11.2773 13H4.72363C3.95581 13 3.47452 12.1706 3.85547 11.5039L4.14355 11H6.5C6.77614 11 7 10.7761 7 10.5C7 10.2239 6.77614 10 6.5 10H4.71484L5.28613 9H7.5C7.77614 9 8 8.77614 8 8.5C8 8.22386 7.77614 8 7.5 8H5.85742L6.79199 6.36426C6.9284 6.1255 7 5.85506 7 5.58008V4.5C7 4.25823 6.82864 4.05622 6.60059 4.00977L6.39941 3.99023C6.17153 3.94364 6 3.74165 6 3.5C6 3.22392 6.22394 3.0001 6.5 3H9.5Z",
    fill: "#1865D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabOrder);
export default __webpack_public_path__ + "static/media/lab-order.c6d586d8b73ae869b2666ad856f0c348.svg";
export { ForwardRef as ReactComponent };